import { Alert } from "@mui/material";

interface Props {
  messageErro: string,
  onTryAgain?: () => void
  onClose?: () => void
}

function AlertError({ messageErro, onTryAgain, onClose }: Props) {
  return (
    <Alert severity="error" variant="filled" onClose={onClose}>
      {messageErro}
      {onTryAgain &&
        <div className=" cursor-pointer font-bold mt-4 underline" onClick={onTryAgain}>
          {"Tentar novamente"}
        </div>
      }
    </Alert>
  );
}

export default AlertError;